import escape from 'lodash/escape';
import escapeRegExp from 'lodash/escapeRegExp';

export default function HighlightText(text, searchTerm) {

    if (!text || text.length === 0) { return text; }

    const escapedText = escape(text.toString());

    if (!searchTerm || searchTerm.length === 0) { return escapedText; }

    const iQuery = new RegExp(escapeRegExp(escape(searchTerm)), "ig");

    return escapedText.replace(iQuery, function(matchedText) {
        return `<span class="highlight">${matchedText}</span>`;
    });
}
